import { render } from "./Img2.vue?vue&type=template&id=2943baa0"
import script from "./Img2.vue?vue&type=script&lang=js"
export * from "./Img2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__